<template>
    <div class="h5_product_service main_color">
        <div v-for="(item, index) in titleData" :key="index" class="item" :style="[{ display: index == 6 ? 'none' : 'block' }]">
            <div class="header" @click="toggle(item)">
                {{ item.title }}
            <img class="arrow" v-if="item.show" src="/static/images2/h5/up.png" alt="">
            <img class="arrow" v-else src="/static/images2/h5/dow.png" alt="">
            </div>
            <transition name="slide">
                <div v-show="item.show" class="body">
                    <div v-if="index == 0">
                        <div class="title">接口介绍</div>
                        <div class="text text1">
                            通过对接接口，可查询17位VIN编码对应的车辆详细信息，包括4S店销售型名称、品牌、型号、年款、排量、变速箱类型、发动机型号等车辆参数数据，
                            帮助用户对车辆信息的真伪、高低配等进行判断。适用于零件采购、二手车估值、车型信息查询等行业或业务领域。</div>
                        <div class="title">优势</div>
                        <div class="text text2">
                            <p>每日最大量的VIN查询量，常年累月的纠错反馈所带来的批量纠错，让数据越来越精准，这也是汽修宝作为汽后行业面向B端用户最大流量平台的优势体现。</p>
                            <p>人工校验，通过大量的人力结合人工智能算法进行建模分析，不断优化，不断验证，目前已累计校验1.3亿，涵盖市场3/5的车型保有量数据。</p>
                            <p>唯一车型，目前市场覆盖品牌、年款等最多的VIN库，也是VIN锁唯一车型覆盖面最大和最准的平台。</p>
                        </div>
                        <div class="dow" @click="download(item)">
                            <img src="/static/images2/product_service_dow.png" alt="">下载接口文档
                        </div>
                    </div>
                    <div class="item" v-if="index == 1">
                        <div class="title">接口介绍</div>
                        <div class="text text1">通过对接接口，可查询90个品牌EPC车辆结构图与配件信息。</div>
                        <div class="title">优势</div>
                        <div class="text text2">
                            <p>业内涵盖品牌数最多，能锁VIN品牌数最多。 </p>
                            <p>各品牌数据结构经过不断的优化，几乎一致，更有利于对接使用，和降低用户的学习成本。</p>
                        </div>
                        <div class="dow" @click="download(item)">
                            <img src="/static/images2/product_service_dow.png" alt="">下载接口文档
                        </div>
                        <img class="product_service_epc" src="/static/images2/product_service_epc.webp" alt="">
                    </div>
                    <div v-if="index == 2">
                        <div class="title">接口介绍</div>
                        <div class="text text1">
                            收录热门品牌车型合共2000万+原厂配件数据，数据信息维度丰富，包含配件适用车型、4S价格、实物规格、替换件、通用件、用量等数据信息</div>
                        <div class="title">优势</div>
                        <div class="text text2">
                            数据准确性高、数据覆盖率全、数据信息丰富、更新速度快
                        </div>
                        <div class="dow" @click="download(item)">
                            <img src="/static/images2/product_service_dow.png" alt="">下载接口文档
                        </div>
                    </div>
                    <div v-if="index == 3">
                        <div class="title">接口介绍</div>
                        <div class="text text1">
                            通过对接接口，可查询车辆官方生产数据与常用配件信息，适用于车型信息查询和确认、二手车行业以及保养快修行业等，包括基本信息、发动机、变速器、 常用维修件、常用磨损件等信息
                        </div>
                        <div class="dow" @click="download(item)">
                            <img src="/static/images2/product_service_dow.png" alt="">下载接口文档
                        </div>
                        <div class="OriginalBox">
                            <div class="img_box">
                                <!-- <div class="index_box"><span>0{{ OriginalIndex }}</span> / 06</div> -->
                                <div class="jt_btn_1 cp">
                                    <img src="/static/images2/return_left.webp" alt=""
                                        @click="setOriginalIndex('left')">
                                </div>
                                <img :src="'/static/images/OriginalBox_' + OriginalIndex + '.jpg'" alt=""
                                    class="OriginalBox_img">
                                <div class="jt_btn_2 cp">
                                    <img src="/static/images2/return_right.webp" alt=""
                                        @click="setOriginalIndex('right')">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="index == 4">
                        <div class="title">接口介绍</div>
                        <div class="text text1">
                            通过对接接口，可查询车辆维修保养记录，对二手车交易的估值环节是一个有效的判断依据。
                        </div>
                        <div class="title">优势</div>
                        <div class="text text2">
                            <p>维修保养多数据展示，异常排查、部件排查、维修保养项目与材料等数据输出！</p>
                            <p>品牌覆盖率高，查得率高达90%，查询速度快，价格实惠！</p>
                        </div>
                        <div class="dow" @click="download(item)">
                            <img src="/static/images2/product_service_dow.png" alt="">下载接口文档
                        </div>
                    </div>
                    <div v-if="index == 5">
                        <div class="title">接口介绍</div>
                        <div class="text text1">
                            用户通过VIN码，便可查询到目标车辆的出险记录，报告将详细解读目标车辆重要部件的损伤情况，为车辆交易、车辆金融、车辆报价评估等业务提供重要的 决策参考依据。
                        </div>
                        <div class="title">优势</div>
                        <div class="text text2">
                            <p>急速响应，利于企业及时获取数据，提升服务体验。</p>
                            <p>标准的接口，对接方式简洁，减少企业开发成本，提高开发效率。</p>
                        </div>
                        <div class="dow" @click="download(item)">
                            <img src="/static/images2/product_service_dow.png" alt="">下载接口文档
                        </div>
                    </div>
                    <div class="item" v-if="index == 7">
                        <div class="title">接口介绍</div>
                        <div class="text text1">
                            通过对接，您的应用将拥有当前市面上最简单、直观、快捷的EPC查询体验。适用于零配件采购、保险定损等行业及领域。是唯一能匹配传统零配 件采购效率和体验的线上解决方案，在保险定损等业务场景，能有效的滤除零件低配高赔的风险，提高效益，形成业务规范。
                        </div>
                        <div class="content_video">
                            <video width="772" height="376" controls >
                            <source src="/static/media/video_epc.mp4" type="video/mp4">
                            <object data="/static/media/video_epc.mp4" width="320" height="240">
                                <embed width="772" height="376" src="movie.swf">
                            </object>
                            </video>
                        </div>
                    </div>
                    <div v-if="index == 8">
                        <div class="title">定制服务</div>
                        <div class="text text1">
                            欢迎各类商务定制开发洽谈，请致电：020-36328593
                        </div>
                        <div class="app_qxb">
                            <img src="/static/images2/app.png" alt="">
                            <div>下载汽修宝APP</div>
                            <div>体验更多功能</div>
                        </div>
                    </div>
                    <div v-if="index == 2 || index == 4 || index == 5" class="content_media_box">
                        <div class="mobile_slide_box">
                            <div class="mobile_slide_con_top">
                                <img src="/static/images/sj_top.png" alt="" class="img_icon1">
                            </div>
                            <div class="mobile_slide_con cp">
                                <img v-if="index == 2" src="/static/images/api_3.jpg" alt="" class="neirong_icon">
                                <img v-if="index == 4" src="/static/images/api_4.jpg" alt="" class="neirong_icon">
                                <img v-if="index == 5" src="/static/images/chuxian.jpg" alt="" class="neirong_icon">
                                <img v-if="index == 6" src="/static/images/chekuang.jpg" alt="" class="neirong_icon">
                            </div>
                            <div class="mobile_slide_con_bottom">
                                <img src="/static/images/sj_bottom.png" alt="" class="img_icon2">
                            </div>
                        </div>
                        <div class="mobile_slide_title">
                            <div class="mobile_slide_title_line"></div>
                            <div class="vertical-text">
                                <span>滑</span>
                                <span>动</span>
                                <span>手</span>
                                <span>机</span>
                                <span>查</span>
                                <span>看</span>
                                <span>演</span>
                                <span>示</span>
                            </div>
                            <div class="mobile_slide_title_line"></div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
import { onEventGsIdo } from '../../utils/index.js'
export default {
    name: "productService",
    data() {
        return {
            type: 'VIN',
            titleData: [
                {
                    title: '车架号(VIN)接口',
                    show: false,
                    type: 'VIN'
                },
                {
                    title: '结构图(EPC)接口',
                    show: false,
                    type: 'EPC'
                },
                {
                    title: 'OEM查询接口',
                    show: false,
                    type: 'OEM'
                },
                {
                    title: '原厂数据查询接口',
                    show: false,
                    type: 'Original'
                },
                {
                    title: '维修保养记录接口',
                    show: false,
                    type: 'Maintain'
                },
                {
                    title: '出险记录接口',
                    show: false,
                    type: 'Danger'
                },
                {
                    title: '车辆状况查询接口',
                    show: false,
                    type: 'Vehicle'
                },
                {
                    title: '简版EPC',
                    show: false,
                    type: 'AbridgedEpc'
                },
                {
                    title: '定制服务',
                    show: false,
                    type: 'CustomizedService'
                }
            ],
            activeIndex: 0,
            OriginalIndex: 1,
        }
    },
    methods: {
        toggle(item) {
            item.show = !item.show
        },
        // download({type}) {
        //     let url = 'https://s1.nanxinwang.com/apps/file/pdf/file2.pdf'
        //     switch (type) {
        //         case 'VIN':
        //             url = 'https://s1.nanxinwang.com/apps/file/pdf/file2.pdf'
        //             break;
        //         case 'EPC':
        //             url = 'https://s1.nanxinwang.com/apps/file/pdf/file4.pdf'
        //             break;
        //         case 'OEM':
        //             url = 'https://s1.nanxinwang.com/apps/file/pdf/file1.pdf'
        //             break;
        //         case 'Original':
        //             url = 'https://s1.nanxinwang.com/apps/file/pdf/file6.pdf'
        //             break;
        //         case 'Maintain':
        //             url = 'https://s1.nanxinwang.com/apps/file/pdf/file5.pdf'
        //             break;
        //         case 'Danger':
        //             url = 'https://s1.nanxinwang.com/apps/file/pdf/file3.pdf'
        //             break;
        //         case 'AbridgedEpc':
        //             url = 'https://s1.nanxinwang.com/apps/file/pdf/file4.pdf'
        //             break;
        //         default:
        //             url = 'https://s1.nanxinwang.com/apps/file/pdf/file2.pdf'
        //     }
        //     window.open(url)
        // },
        download({type}) {
            let url = 'https://s1.nanxinwang.com/apps/file/pdf/file2.pdf'
            switch (type) {
                case 'VIN':
                    url = 'https://s1.nanxinwang.com/apps/file/pdf/file2.pdf'
                    onEventGsIdo('qxb_$VIN', '下载VIN接口文档')
                    break;
                case 'EPC':
                    url = 'https://s1.nanxinwang.com/apps/file/pdf/file4.pdf'
                    onEventGsIdo('qxb_$EPC', '下载EPC接口文档')
                    break;
                case 'OEM':
                    url = 'https://s1.nanxinwang.com/apps/file/pdf/file1.pdf'
                    onEventGsIdo('qxb_$OEM', '下载OEM接口文档')
                    break;
                case 'Original':
                    url = 'https://s1.nanxinwang.com/apps/file/pdf/file6.pdf'
                    onEventGsIdo('qxb_$Original', '下载原厂接口文档')
                    break;
                case 'Maintain':
                    url = 'https://s1.nanxinwang.com/apps/file/pdf/file5.pdf'
                    onEventGsIdo('qxb_$Maintain', '下载维保接口文档')
                    break;
                case 'Danger':
                    url = 'https://s1.nanxinwang.com/apps/file/pdf/file3.pdf'
                    onEventGsIdo('qxb_$Danger', '下载出险接口文档')
                    break;
                case 'AbridgedEpc':
                    url = 'https://s1.nanxinwang.com/apps/file/pdf/file4.pdf'
                    onEventGsIdo('qxb_$EPC', '下载EPC接口文档')
                    break;
                default:
                    url = 'https://s1.nanxinwang.com/apps/file/pdf/file2.pdf'
                    onEventGsIdo('qxb_$VIN', '下载VIN接口文档')
            }
            window.open(url)
        },
        setOriginalIndex(type) {
            if (type == 'left') {
                --this.OriginalIndex
                if (this.OriginalIndex <= 0) {
                    this.OriginalIndex = 6
                }
            } else {
                ++this.OriginalIndex
                if (this.OriginalIndex >= 7) {
                    this.OriginalIndex = 1
                }
            }
        },
    },
}
</script>
<style lang="less" scoped>
@import "../../assets/style/utils.less";
@media screen and (max-width: 900px) {
    .h5_product_service {
        padding: 0 .h5px2vw(24)[@result] .h5px2vw(32)[@result];
        .header {
            padding: .h5px2vw(30)[@result] 0;
            border-bottom: .h5px2vw(1)[@result] solid #e5e6eb;
            cursor: pointer;
            font-size: .h5px2vw(28)[@result];
            font-weight: 500;
            position: relative;
            display: flex;
            align-items: center;
            .arrow {
                width: .h5px2vw(24)[@result];
                height: .h5px2vw(24)[@result];
                margin-left: .h5px2vw(8)[@result];
                transition: transform 0.3s ease;
            }
            &:active {
                background-color: #ffffff;
            }
        }
        .body {
            overflow: hidden;
            margin-top: .h5px2vw(24)[@result];
            padding-bottom: .h5px2vw(16)[@result];
            ul {
                list-style-type: none;
                margin: 0;
                li {
                    padding: .h5px2vw(30)[@result] 0;
                }
            }
        }
        .slide-enter-active,
        .slide-leave-active {
            transition: max-height 0.3s ease-out;
            max-height: 900px; /* 初始最大高度 */
            overflow: hidden;
        }
        .slide-enter,
        .slide-leave-to {
            max-height: 0;
        }

        .item {
            text-align: center;
        }
        .title {
            font-weight: 500;
            font-size: .h5px2vw(28)[@result];
            line-height: .h5px2vw(36)[@result];
            margin-bottom: .h5px2vw(16)[@result];
            text-align: left;
        }
        .text {
            font-weight: 400;
            font-size: .h5px2vw(24)[@result];
            line-height: .h5px2vw(32)[@result];
            text-align: left;
        }
        .text1 {
            margin-bottom: .h5px2vw(32)[@result];
        }
        .text2 {
            margin-bottom: .h5px2vw(40)[@result];
        }
        .dow {
            display: flex;
            align-items: center;
            justify-content: center;
            width: .h5px2vw(528)[@result];
            height: .h5px2vw(80)[@result];
            font-size: .h5px2vw(28)[@result];
            color: #165DFF;
            border-radius: .h5px2vw(2)[@result];
            border: 1px solid #165DFF;
            margin: 0 auto .h5px2vw(24)[@result];
            img {
                width: .h5px2vw(32)[@result];
                height: .h5px2vw(32)[@result];
                margin-right: .h5px2vw(3)[@result];
            }
        }
        .product_service_epc {
            width: .h5px2vw(640)[@result];
            height: .h5px2vw(361)[@result];
            margin: 0 auto;
        }
        
        .content_video{
            width: .h5px2vw(658)[@result];
            height: .h5px2vw(334)[@result];
            margin: 0 auto;
            video {
                width: 100%;
                height: 100%;
            }
        }
        .app_qxb {
            text-align: center;
            font-size: .h5px2vw(24)[@result];
            line-height: .h5px2vw(32)[@result];
            img {
                width: .h5px2vw(220)[@result];
                height: .h5px2vw(220)[@result];
                margin-bottom: .h5px2vw(16)[@result];
            }
        }
    }
}

.OriginalBox {
    .img_box {
        width: .h5px2vw(480)[@result];
        height: .h5px2vw(480)[@result];
        position: relative;
        margin: 0 auto;

        .index_box {
            font-size: .h5px2vw(16)[@result];
            color: #999;

            span {
                color: #000;
            }

            position: absolute;
            right: .h5px2vw(18)[@result];
            width: .h5px2vw(100)[@result];
            top: .h5px2vw(30)[@result];
            height: .h5px2vw(30)[@result];
            line-height: .h5px2vw(30)[@result];
        }

        .OriginalBox_img {
            width: .h5px2vw(480)[@result];
            height: .h5px2vw(480)[@result];
        }

        .jt_btn_1 {
            position: absolute;
            width: .h5px2vw(64)[@result];
            height: .h5px2vw(64)[@result];
            top: 50%;
            left: .h5px2vw(-100)[@result];
            transform: translate(0, -50%);
            background-color: #E8E9ED;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
                width: .h5px2vw(32)[@result];
                height: .h5px2vw(32)[@result];
            }
        }

        .jt_btn_2 {
            position: absolute;
            width: .h5px2vw(64)[@result];
            height: .h5px2vw(64)[@result];
            top: 50%;
            right: .h5px2vw(-100)[@result];
            transform: translate(0, -50%);
            background-color: #E8E9ED;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
                width: .h5px2vw(32)[@result];
                height: .h5px2vw(32)[@result];
            }
        }
    }

    .zhu {
        font-size: .h5px2vw(16)[@result];
        text-align: left;
        margin-left: .h5px2vw(10)[@result];
        margin-top: .h5px2vw(30)[@result];
        color: #646A7F;
    }
}

// 改旧样式
.content_media_box {
    display: flex;
    align-items: center;
    justify-content: center;
    .mobile_slide_box {
        text-align: center;

        .mobile_slide_con::-webkit-scrollbar {
            width: 0px;
            height: 0px;
        }

        .mobile_slide_con .-o-scrollbar {
            -moz-appearance: none !important;
            background: rgba(0, 255, 0, 0) !important;
        }

        .mobile_slide_con {
            -ms-scroll-chaining: chained;
            -ms-overflow-style: none;
            -ms-content-zooming: zoom;
            -ms-scroll-rails: none;
            -ms-content-zoom-limit-min: 100%;
            -ms-content-zoom-limit-max: 500%;
            -ms-scroll-snap-type: proximity;
            -ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
            -ms-overflow-style: none;
            overflow: auto;
        }

        .mobile_slide_con_top {
            width: .h5px2vw(373)[@result];
            .img_icon1 {
                width: 100%;
            }
        }

        .mobile_slide_con {
            position: relative;
            width: .h5px2vw(373)[@result];
            height: .h5px2vw(542)[@result];
            overflow-y: auto;
            // margin: 0 auto;
            background: url(/static/images/sj_con.png) no-repeat;
            background-size: cover;
            box-sizing: border-box;

            /*padding-top: 20px;*/
            /*padding-bottom: 20px;*/
            .img_icon1 {
                width: .h5px2vw(373)[@result];
                height: .h5px2vw(699)[@result];
                position: absolute;
                top: 0;
                left: 50%;
                transform: translate(-50%, 0);
            }

            .neirong_icon {
                width: .h5px2vw(276)[@result];
                margin-left: .h5px2vw(16)[@result];
                /*height: 1127px;*/
            }
        }
        .mobile_slide_con_bottom {
            width: .h5px2vw(373)[@result];
            .img_icon2 {
                width: 100%;
            }
        }
    }
    .mobile_slide_title {
        .mobile_slide_title_line {
            height: .h5px2vw(152)[@result];
            width: 1px;
            background-color: #1D2129;
            margin-left: .h5px2vw(8)[@result];
        }
        .vertical-text {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: .h5px2vw(20)[@result];
            font-weight: 400;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/productService/h5_product_service.vue